import { render, staticRenderFns } from "./DisappearingTBody.vue?vue&type=template&id=256f2d58&scoped=true"
import script from "./DisappearingTBody.vue?vue&type=script&lang=js"
export * from "./DisappearingTBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256f2d58",
  null
  
)

export default component.exports